import { Box } from '@mui/material';
import { FileDetailSection } from 'modules';
import React from 'react';



export type FileActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FileActivity = (props: FileActivityProps) => {


  return (

    <Box>
      <FileDetailSection.FC />
    </Box>
  );

};
